import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { BankAccountModel } from "./oldbankaccount.model";
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { UserBankAccountsConst } from "../../../../modules/user/const";
import { DummyComponent } from "../../../../shared/dummy.component";
import { ReconciliationService } from "../../../../modules/conciliation/reconciliation.service";
import { TableService } from "../../../../shared/components/table/table.service";
import { BankTypeEnum } from "../../../../shared/data-types";
import { SubscriptionService } from "../../../../modules/subscription/subscription.service";
import { consts } from "../../../../consts";
import { Utils } from "../../../../shared/utils";
import { BankAccountService } from '../../../../modules/finanzas/bancos/bankaccount.service';

@Component({
    selector: "old-convfact-bankaccount-list",
    templateUrl: "./old-bankaccount-list.component.html",
    styleUrls: ["./old-bankaccount.component.css"],
    standalone: false
})
export class OldBankAccountListComponent implements OnInit {
  currentPage = 1;
  itemsPerPage = 10;
  totalItems = 0;

  constructor(
    private router: Router,
    private bankAccountService: BankAccountService,
    public dialog: MatDialog,
    public dummy: DummyComponent,
    private reconciliationService: ReconciliationService,
    public snackBar: MatSnackBar,
    private tableService: TableService,
    private subscriptionService: SubscriptionService,
  ) { }

  dataSource: BankAccountModel[] = [];
  empty = false;
  ready = false;
  headerTable: any[] = UserBankAccountsConst.headerTable;

  conciliation_active: boolean = false;

  ngOnInit() {
    this.getList();
    this.getSubscriptionActives();
  }

  public getSubscriptionActives() {
    this.subscriptionService.getActive().then(response => {
      if (response && response.length > 0) {
        this.conciliation_active = response.filter(c => c.alias === 'SUBSCRIPTION_RECONCILIATION').length > 0;
      }
    });
  }

  public getList() {
    this.bankAccountService
      .getList(this.currentPage, this.itemsPerPage)
      .then((data) => {
        this.tableService.set(data.list);
        this.dataSource = data.list;
        this.totalItems = data.totalItems;
        if (this.dataSource.length == 0) {
          this.empty = true;
        } else {
          this.empty = false;
          this.getStatusConectionList();
        }
        this.ready = true;
      });
  }

  public pageChanged(event: any) {
    this.currentPage = event.page;
    this.getList();
  }

  private getStatusConectionList(): void {
    this.reconciliationService
      .getAllBankStatusRequisition()
      .then((response) => {
        if (response == null) {
          this.dataSource = this.dataSource.map((element) => {
            const value = element;
            value.connected = false;
            return value;
          });
        }

        if (response != undefined) {
          const resultUids = response.map((x) => x.bankId);

          this.dataSource = this.dataSource.map((element) => {
            const value = element;
            if (resultUids.includes(value.id)) {
              value.connected = true;
            } else {
              value.connected = false;
            }
            return value;
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  public reconcile(uid: string): void {

    if (!this.conciliation_active) {
      if (!Utils.IsTierFour()) {
        this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
        return;
      }
    }

    const bankSelected = this.dataSource.find(x => x.uid === uid);

    this.router.navigate(["/finance/reconciliation/bankaccounts/", uid, "conciliation"], { queryParams: { bankId: bankSelected.id, bankTypeId: BankTypeEnum.Banco } });
  }

  public enableAutomaticRecurrent(uid: string): void {
    const bankSelected = this.dataSource.find(x => x.uid === uid);

    this.reconciliationService.enableAutomaticRecurrent(bankSelected.id, BankTypeEnum.Banco)
      .then(response => {
        this.getList();
      })
      .catch(err => {
        this.getList();
      });
  }

  public disableAutomaticRecurrent(uid: string): void {
    const bankSelected = this.dataSource.find(x => x.uid === uid);

    this.reconciliationService.disableAutomaticRecurrent(bankSelected.id, BankTypeEnum.Banco)
      .then(response => {
        this.getList();
      })
      .catch(err => {
        this.getList();
      });
  }

  public isEnabled(uid: string): boolean {
    const bankSelected = this.dataSource.find(x => x.uid === uid);

    return bankSelected.isAutoReconciliationEnabled;
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    this.snackBar.open(message, "", options);
  }
}
